<template>
  <v-dialog :value="dialog" modal transition="dialog-bottom-transition" :fullscreen="e6 > 1">
    <v-card>
      <v-stepper v-model="e6" vertical>
        <v-btn fab icon absolute dark top right @click="closeDialog" color="primary" class="mt-8">
          <v-icon large>mdi-close-circle-outline</v-icon>
        </v-btn>
        <v-stepper-step :complete="e6 > 1" step="1">
          {{ $t("excel.ExcelUpload.step1Text") }}
          <small>{{ $t("excel.ExcelUpload.step1Small") }}</small>
        </v-stepper-step>

        <v-stepper-content step="1">
          <v-container>
            <p>
              {{ $t("excel.ExcelUpload.stepContentText") }}
              <a href="/TripLoopItinerary.xlsx" download>
                {{ $t("excel.ExcelUpload.stepContentLink") }}
              </a>
            </p>

            <v-card class="mx-auto mt-4" max-width="500">
              <ExcelDragAndDrop
                class="pa-4"
                height="300"
                :loading="loading"
                :title="$t('excel.ExcelUpload.titleCard')"
                v-on:update:file="fileAdded($event)"
              />
            </v-card>
          </v-container>
        </v-stepper-content>

        <v-stepper-step :complete="e6 > 2" step="2" class="mt-n4">
          {{ $t("excel.ExcelUpload.summary") }}
          <small>
            {{ $t("excel.ExcelUpload.reviewAndConfirm") }}
          </small>
        </v-stepper-step>
        <v-stepper-content step="2">
          <v-container class="d-flex flex-column" style="max-height: 80vh">
            <v-checkbox
              v-model="show_bulks"
              :label="$t('itinerary.NewEvent.bulkActions')"
            ></v-checkbox>
            <v-card v-show="show_bulks" elevation="4" class="mt-1 mb-3 mx-4" max-width="800px">
              <v-card-text class="mb-n4 mt-n4">
                <v-row>
                  <v-col cols="8">
                    <h4>{{ $t("common.attendance") }}</h4>
                    <div>
                      <v-btn-toggle
                        v-model="bulkInvitedMode"
                        persistent-hint
                        mandatory
                        hin
                        rounded
                        dense
                        color="primary"
                      >
                        <v-btn v-for="type in privacy" :key="type.value" :value="type.value">{{
                          type.text
                        }}</v-btn>
                      </v-btn-toggle>
                      <p>{{ privacyHint }}</p>
                    </div>
                  </v-col>
                  <v-col cols="6" v-if="bulkInvitedMode == 4">
                    <h4>
                      {{ $t("common.selectedUsers") }}
                    </h4>
                    <v-select
                      class="pr-2"
                      multiple
                      v-model="invitedUsers"
                      :items="allUsers"
                      hide-details
                      item-text="name"
                      item-value="id"
                      :label="this.$t('common.attendance')"
                      single-line
                    >
                      <template v-slot:selection="{ index }">
                        <span v-if="index === 1" class="grey--text text--darken-2">
                          {{ invitedUsers.length }}
                          selected
                        </span>
                      </template>
                    </v-select>
                  </v-col>
                  <v-col cols="6" v-if="bulkInvitedMode == 3">
                    <h4>
                      {{ $t("itinerary.NewEvent.selectedSubgroups") }}
                    </h4>
                    <v-select
                      multiple
                      v-model="subgroups"
                      :items="allSubgroups"
                      item-text="name"
                      item-value="id"
                      hide-details
                      :label="$t('navbar.menu.subgroups')"
                      single-line
                    ></v-select>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6">
                    <h4>
                      {{ $t("common.remindersHint") }}
                    </h4>
                    <v-select class="ma-0 py-0" :items="reminders" v-model="reminder"></v-select>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn class="primary" @click="updateEvents">
                  {{ $t("buttons.apply") }}
                </v-btn>
              </v-card-actions>
            </v-card>
            <div class="overflow-y-auto flex-grow-1">
              <template v-if="events.length > 0 || travels.length > 0">
                <v-row v-if="events.length > 0">
                  <v-subheader class="primary headline white--text" style="width: 100%">
                    {{ $t("common.events") }}
                  </v-subheader>
                  <v-col v-for="(event, index) in events" :key="event.id" cols="12">
                    <ExcelUploadEvent
                      ref="excelUploadEvent"
                      :excelEvent="event"
                      @remove="deleteEvent(index, $event)"
                    />
                  </v-col>
                </v-row>
                <v-row v-if="travels.length > 0">
                  <v-subheader class="primary headline white--text" style="width: 100%">
                    {{ $t("common.travels") }}
                  </v-subheader>
                  <v-col v-for="(travel, index) in travels" :key="travel.id" cols="12">
                    <ExcelUploadTravel
                      ref="excelUploadEventTravel"
                      :excelActivity="travel"
                      @remove="deleteTravel(index, $event)"
                    />
                  </v-col>
                </v-row>
              </template>
              <div v-else>
                <v-card class="my-2 mx-2">
                  <v-card-title>{{ $t("excel.ExcelUpload.noEvents") }}</v-card-title>
                  <v-card-subtitle>{{ $t("excel.ExcelUpload.canClose") }}</v-card-subtitle>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" @click="closeDialog">{{ $t("common.close") }}</v-btn>
                  </v-card-actions>
                </v-card>
              </div>
            </div>
          </v-container>
        </v-stepper-content>
      </v-stepper>
    </v-card>
    <v-snackbar v-model="snackbar">
      {{ snackText }}
      <v-btn color="primary" text @click="snackbar = false">{{ $t("common.close") }}</v-btn>
    </v-snackbar>
  </v-dialog>
</template>

<script>
import ExcelDragAndDrop from "@/components/Excel/ExcelDragAndDrop";
import ExcelUploadEvent from "@/components/Excel/ExcelUploadEvent";
import ExcelUploadTravel from "@/components/Excel/ExcelUploadTravel";
import excelProcessor from "@/components/Excel/excelProcessor";
import reminders from "@/assets/reminders";

export default {
  name: "ExcelUpload",
  props: ["dialog"],
  components: {
    ExcelDragAndDrop,
    ExcelUploadEvent,
    ExcelUploadTravel,
  },
  data() {
    return {
      // dialog: false,
      loading: false,
      bulkInvitedMode: 2,
      reminder: null,
      invitedUsers: null,
      show_bulks: false,
      e6: 1,
      file: null,
      events: [],
      travels: [],
      subgroups: [],

      snackbar: false,
      snackText: "",

      reminders: reminders.options(this.$i18n),
      privacy: [
        {
          value: 2,
          text: this.$i18n.t("common.privacy.everyone.text"),
          hint: this.$i18n.t("common.privacy.everyone.hint"),
        },
        {
          value: 1,
          text: this.$i18n.t("common.privacy.optional.text"),
          hint: this.$i18n.t("common.privacy.optional.hint"),
        },
        {
          value: 3,
          text: this.$i18n.t("common.privacy.subgroups.text"),
          hint: this.$i18n.t("common.privacy.subgroups.hint"),
        },
        {
          value: 4,
          text: this.$i18n.t("common.privacy.custom.text"),
          hint: this.$i18n.t("common.privacy.custom.hint"),
        },
      ],
    };
  },
  watch: {
    steps(val) {
      if (this.e1 > val) {
        this.e1 = val;
      }
    },
  },

  methods: {
    updateEvents() {
      // eslint-disable-next-line no-restricted-syntax,  guard-for-in
      for (const i in this.events) {
        this.$refs.excelUploadEvent[i].updateUserSubgroups(
          this.invitedUsers,
          this.subgroups,
          this.bulkInvitedMode,
          this.reminder,
        );
      }
      // eslint-disable-next-line no-restricted-syntax,  guard-for-in
      for (const i in this.travels) {
        this.$refs.excelUploadEventTravel[i].updateUserSubgroupsTravels(
          this.invitedUsers,
          this.subgroups,
          this.bulkInvitedMode,
          this.reminder,
        );
      }
    },
    fileAdded(file) {
      this.loading = true;
      console.log("file addded", file);
      excelProcessor
        .parseSpreadsheet(file)
        .then((itinerary) => {
          console.log("succesfully parsed");
          this.e6 += 1;
          console.log(itinerary.events);
          this.events = itinerary.events;
          this.travels = itinerary.travels;
          this.loading = false;
        })
        .catch((e) => {
          console.log("error from spread", e);
          this.snackText = "An error ocurred while parsing the file";
          this.snackbar = true;
          this.loading = false;
        });
    },
    nextStep(n) {
      if (n === this.steps) {
        this.e1 = 1;
      } else {
        this.e1 = n + 1;
      }
    },
    deleteEvent(index, saved) {
      console.log("should remove at: ", index, `count is${this.events.length}`);
      this.events.splice(index, 1);
      console.log(`new length is ${this.events.length}`);

      this.snackText = saved
        ? this.$t("excel.ExcelUpload.saved")
        : this.$t("excel.ExcelUpload.removed");
      this.snackbar = true;
    },
    deleteTravel(index, saved) {
      this.travels.splice(index, 1);

      this.snackText = saved
        ? this.$t("excel.ExcelUpload.saved")
        : this.$t("excel.ExcelUpload.removed");
      this.snackbar = true;
    },
    closeDialog() {
      // dialog=false
      this.$emit("closed");
    },
  },
  created() {},
  computed: {
    allUsers() {
      return this.$store.getters.allUsers;
    },
    allSubgroups() {
      return Object.values(this.$store.state.trip.subgroups);
    },
    privacyHint() {
      return this.privacy.filter((item) => item.value === this.bulkInvitedMode)[0].hint;
    },
  },
};
</script>
